export default "__VITE_ASSET__SFq0aTLm__"